import { SerializedStyles } from "@emotion/react"
import { MouseEvent } from "react"
import styled from "@emotion/styled"

import SpinnerIcon from "../ui/images/spinner-icon"

const Button = styled.button<{ customStyles?: SerializedStyles }>`
  background: linear-gradient(180deg, #30ab76 0%, #71c552 100%);
  border-radius: 5px;
  height: 48px;
  padding: 12px 64px;
  color: #ffffff;
  text-transform: none;
  cursor: pointer;
  border: 0;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);

  ${(props) => props.customStyles}
`

const FakeButton = styled.div<{ customStyles?: SerializedStyles }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  background: linear-gradient(180deg, #30ab76 0%, #71c552 100%);
  border-radius: 5px;
  padding: 12px 64px;
  color: #ffffff;
  border: 0;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);

  ${(props) => props.customStyles}
`

const DisabledButton = styled.div<{ customStyles?: SerializedStyles }>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  background-color: #c2c2c2;
  border-radius: 5px;
  padding: 12px 64px;
  color: #ffffff;
  border: 0;

  ${(props) => props.customStyles}
`

type Props = {
  loading?: boolean
  disabled?: boolean
  type?: "button" | "reset" | "submit" | undefined
  style?: SerializedStyles
  disabledStyle?: SerializedStyles
  loadingStyle?: SerializedStyles
  children: any
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
  className?: string
}

const ButtonCustom = ({
  loading = false,
  disabled = false,
  type = "button",
  style,
  disabledStyle,
  loadingStyle,
  children,
  onClick,
  className
}: Props) => {
  if (loading) {
    return (
      <FakeButton customStyles={loadingStyle}>
        <SpinnerIcon />
      </FakeButton>
    )
  }

  if (disabled) {
    return <DisabledButton customStyles={disabledStyle}>{children}</DisabledButton>
  }

  return (
    <Button customStyles={style} type={type} onClick={onClick} className={className}>
      {children}
    </Button>
  )
}

export default ButtonCustom
